import { GridColumns } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  PositionDrawingCategoryCell,
  PositionDrawingNumberCell,
  PositionDrawingOpsCell,
  PositionDrawingPreviewCell,
  PositionDrawingProductsCell,
} from './positionDrawingTableCells'

export const usePositionDrawingTableColumns = (
  onEdit: (id: EntityId) => void,
  onDelete: (id: EntityId) => void,
  isDeleting: boolean,
): GridColumns => {
  const { t } = useTranslation(['admin-position-drawing', 'common'])

  return useMemo(
    () => [
      {
        field: 'fileUrl',
        headerName: t(''),
        width: 52,
        sortable: false,
        disableColumnMenu: true,
        renderCell: params => <PositionDrawingPreviewCell {...params} />,
      },
      {
        field: 'drawingNumber',
        headerName: t('tableDrawingNumber'),
        width: 110,
        sortable: false,
        disableColumnMenu: true,
        renderCell: params => <PositionDrawingNumberCell {...params} />,
      },
      {
        field: 'category',
        headerName: t('category', { ns: 'common' }),
        width: 130,
        sortable: false,
        disableColumnMenu: true,
        renderCell: params => <PositionDrawingCategoryCell {...params} />,
      },
      {
        field: 'positionDrawingProductNumbers',
        headerName: t('associatedProducts'),
        flex: 1,
        minWidth: 180,
        sortable: false,
        disableColumnMenu: true,
        renderCell: params => <PositionDrawingProductsCell {...params} />,
      },
      {
        field: 'actions',
        headerName: '',
        width: 80,
        sortable: false,
        disableColumnMenu: true,
        align: 'right',
        headerAlign: 'right',
        renderCell: params => (
          <PositionDrawingOpsCell {...params} onEdit={onEdit} onDelete={onDelete} disabled={isDeleting} />
        ),
      },
    ],
    [isDeleting, onDelete, onEdit, t],
  )
}